// TODO: назвал файл others, потому что не понял пока к чему ближе эти хелперы
import cookies from 'js-cookie';

import type { TAdditionalInfoVariations } from '../models';
import {
    BROKERAGE_ACCOUNT,
    DEFAULT_PLATFORM_ID,
    PLATFORM_ID_KEY,
    BROKERAGE_CHILD_MIN_AGE,
    BROKERAGE_CHILD_MAX_AGE,
} from '../constants';

/** Вычисляет возраст в годах на основе даты рождения */
export const calculateAge = (birthDate: string): number => {
    const birthDateTime = new Date(birthDate).getTime();
    const currentDate = new Date().getTime();

    /**
     * Количество миллисекунд в году:
     * 365.25 - дней в году (учитываем високосные годы)
     * 24 - часов в сутках
     * 60 - минут в часе
     * 60 - секунд в минуте
     * 1000 - миллисекунд в секунде
     */
    return Math.floor((currentDate - birthDateTime) / (365.25 * 24 * 60 * 60 * 1000));
};

/** Вычисляет, подходит ли пользователь по возрасту в категорию детского брокерского счета*/
export const checkChildBrokerage = ({
    passportBirthDate,
    minAge = BROKERAGE_CHILD_MIN_AGE,
    maxAge = BROKERAGE_CHILD_MAX_AGE,
}: {
    maxAge?: number;
    minAge?: number;
    passportBirthDate?: string;
}) => {
    if (!passportBirthDate) return false;

    const userAge = calculateAge(passportBirthDate);

    return userAge >= minAge && userAge < maxAge;
};

/** Проверяем, нужно ли показывать плашку для детского брокерского счета через стор, если
 * 1) Пользователю менее 18 лет
 * 2) Пользователь выбрал дополнительный продукт брокерский счет (BROKERAGE_ACCOUNT) на втором шаге
 */
export const getAdditionalInfoVariation = (
    passportBirthDate: string | undefined,
    services: string[] | undefined
): TAdditionalInfoVariations => {
    if (!(passportBirthDate && services)) return 'default';

    const age = calculateAge(passportBirthDate);

    return age >= BROKERAGE_CHILD_MIN_AGE &&
        age < BROKERAGE_CHILD_MAX_AGE &&
        services.includes(BROKERAGE_ACCOUNT)
        ? 'childrenBrokerage'
        : 'default';
};

/** Функция пытается получить platformId из куки и квери. Если не находит, то возвращает дефолтное значение */
export const getPlatformId = (): string => {
    const query = new URLSearchParams(window?.location.search);
    const platformIdFromParams = query.get(PLATFORM_ID_KEY);

    if (platformIdFromParams) {
        return platformIdFromParams;
    }

    const platformIdFromCookie = cookies.get(PLATFORM_ID_KEY);

    if (platformIdFromCookie) {
        return platformIdFromCookie;
    }

    return DEFAULT_PLATFORM_ID;
};
